<script>
  import { tausender_trenner } from "./UtilsBalkenProgress.svelte";
  import { find_help_text_if_exists } from "./Utils.svelte";

  export let helptexts;
  export let in_show_helptext_id;

  export let max_value;

  let heigth = 110;
  let text_box_heigh = 7;

  export let background_color_bottom = "#afcb08";
  export let background_color_mitte = "#ffffff";
  export let border_color_mitte = "#44546a";

  export let vorgaenger_box_color = false;
  export let is_basis_balken = false;

  export let oberer_text;
  export let unterer_text;

  export let is_total = false;

  export let gruen;
  export let deactivated_animals = 0;
  export let basis;

  function lower_heigth(max_value, gruen) {
    var heigth_faktor = heigth / max_value;
    return gruen * heigth_faktor;
  }

  function vorgaenger_heigth(max_value, gruen, basis) {
    var heigth_faktor = heigth / max_value;
    return basis * heigth_faktor - deactivated_heigth(max_value, gruen);
  }

  function deactivated_heigth(max_value) {
    var heigth_faktor = heigth / max_value;
    return deactivated_animals * heigth_faktor;
  }

  function upper_heigth(max_value, gruen, basis) {
    if (is_total > 0) {
      // console.log("vorgaenger_heigth: ", vorgaenger_heigth(max_value, gruen, basis))
      // console.log("lower_heigth: ", lower_heigth(max_value, gruen, basis))
      // console.log("deactivated_heigth: ", deactivated_heigth(max_value, gruen, basis))
      // console.log("upper_heigth: ", heigth - (vorgaenger_heigth(max_value, gruen, basis) + lower_heigth(max_value, gruen, basis)))
    }

    return heigth - (vorgaenger_heigth(max_value, gruen, basis) + lower_heigth(max_value, gruen));
  }
</script>

<div class="center-outer" style="margin-left: 0px;margin-right: 0px;margin-top: 0px;">
  <table height="{heigth}px;">
    <tr height="{upper_heigth(max_value, gruen, basis)}px;">
      <div class="breite"><!-- &nbsp; --></div>
    </tr>
    <tr height="{text_box_heigh}px;">
      <div
        class="breite borderstyle"
        max-height="{upper_heigth(max_value, gruen, basis)}px;"
        style="background-color: {background_color_mitte}; border: solid {border_color_mitte}  0.25pt; text-align: center; vertical-align: middle; padding:0px;"
      >
        {tausender_trenner(oberer_text)}
      </div>
    </tr>

    <tr style="height: 1px; max-height: 1px; padding:0px;">
      <div style="height: 1px; max-height: 1px;"><!-- &nbsp; --></div>
    </tr>

    <tr height="{lower_heigth(max_value, gruen)}px;">
      <td style="vertical-align: center; padding:0px; height:100%;">
        <div
          class="breite"
          style="max-height:{lower_heigth(max_value, gruen)}px;
          text-align:  center; vertical-align: center; background-color: {background_color_bottom}"
        >
          {#if is_total}
            +{tausender_trenner(gruen)}
          {/if}
        </div>
      </td>
      {#if is_total}
        <td class="hoverclass" style="vertical-align: top">
          <div
            class="breite einmarker"
            style="
            max-height:{lower_heigth(max_value, gruen)}px;
              text-align:  center;height: 12px;  color: #FFFFFF; background-color: {background_color_bottom}"
          >
            New
          </div>
          <div class="info-box-auf-hoehe">
            {#if find_help_text_if_exists(helptexts, "marketing_mirror_new_clients_1")}
              {@html find_help_text_if_exists(helptexts, "marketing_mirror_new_clients_1")}
            {:else}
              <p>
                <strong>New customers</strong> &hellip; Total number of new customers in reporting timeframe (based on the date of the first
                order or the &ldquo;customer since&rdquo; date)
              </p>
            {/if}
            {#if in_show_helptext_id}
              <div style="font-size: 7px">id: marketing_mirror_new_clients_1</div>
              <div style="font-size: 7px">
                [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
              </div>
            {/if}
          </div>
        </td>
      {/if}
    </tr>

    {#if basis > 0}
      <tr height="{vorgaenger_heigth(max_value, gruen, basis)}px;">
        <td class="text-align:center;" style="padding:0px;">
          <div
            class="breite"
            style="{vorgaenger_box_color
              ? 'background-color: ' + vorgaenger_box_color + '; color: ' + '#000000; vertical-align: bottom;'
              : 'vertical-align: top;'} {is_basis_balken ? 'color: #FFFFFF;' : 'color: #455F51;'} 
               opacity: 1.0;
               border-top: solid 0.25pt #d9d9d9;
               border-left: solid 0.25pt #d9d9d9;
               border-right: solid 0.25pt #d9d9d9;
               text-align: center;

       {vorgaenger_heigth(max_value, gruen, basis) > 20 ? 'padding-top: 2px;' : 'padding-top: 0px;'} 
       
       height:{vorgaenger_heigth(max_value, gruen, basis)}px;
       "
          >
            {#if !is_total}
              {#if gruen != 0}
                +
              {/if}
            {:else}
              {tausender_trenner(basis)}

              <div style="color:#A47A12;">
                <!-- -{tausender_trenner(deactivated_animals)} -->
              </div>
            {/if}
            {tausender_trenner(unterer_text)}

            {#if deactivated_animals > 0 && !is_total}
              <div style="color:#A47A12;">
                <!-- -{tausender_trenner(deactivated_animals)} -->
              </div>
            {/if}
          </div>
        </td>
        {#if is_total}
          <td class="hoverclass">
            <div
              class="breite"
              style="text-align:  center;
            height:{vorgaenger_heigth(max_value, gruen, basis) >= 12 ? 12 : vorgaenger_heigth(max_value, gruen, basis)}px;
            color: #000000; background-color: #d9d9d9"
            >
              Basis
            </div>
            <div class="info-box-auf-hoehe">
              {#if find_help_text_if_exists(helptexts, "sales_mirror_new_clients_2")}
                {@html find_help_text_if_exists(helptexts, "sales_mirror_new_clients_2")}
              {:else}
                <p>
                  <strong>Basis</strong> &hellip; Total number of customers who were already customer at the beginning of the reporting timeframe.
                </p>
              {/if}
              {#if in_show_helptext_id}
                <div style="font-size: 7px">id: sales_mirror_new_clients_2</div>
                <div style="font-size: 7px">
                  [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                </div>
              {/if}
            </div>
          </td>
        {/if}
      </tr>
    {/if}
  </table>
</div>

<style>
  .center-outer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div {
    height: 100%;
    font-size: 10px;
    overflow: hidden;
    text-overflow: auto;
    white-space: nowrap;
  }
  .breite {
    width: 40px;
  }
  .center-text {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  /*tr {
    width: 40px;
  }*/

  td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  tr {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 11.5px;
    height: auto;
    width: auto;
    margin-left: 40px;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: inherit;
    /*    left: var(--x);*/
    right: 0%;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 11.5px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: var(--y);
    left: var(--x);
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
